<template>
  <div
    class="sc-chat-window"
    :class="{
      opened: chatStatus === 'active',
      closed: chatStatus !== 'active',
    }"
  >
    <Header
      :title="title"
      :subtitle="subtitle"
      :image-url="imageUrl"
      :is-embedded="isEmbedded"
      :on-close="onClose"
      :colors="colors"
      :css-style="cssStyle"
    />
    <!-- FORMULARIOS -->
    <LoginForm
      v-if="currentForm == 'Login'"
      :company-name="companyName"
      :on-close="onClose"
      :welcome-form-logo="welcomeFormLogo"
    />
    <Score
      v-if="currentForm == 'Score'"
      :css-style="cssStyle"
      :company-name="companyName"
    />
    <ScoreConversation
      v-if="currentForm == 'ScoreConversation'"
      :css-style="cssStyle"
      :company-name="companyName"
    />
    <ContactForm v-if="currentForm == 'ContactForm'" />
    <CotizacionForm v-if="currentForm == 'CotizacionForm'" />
    <DiasLibresForm v-if="currentForm == 'DiasLibresForm'" />
    <ChatbotRequestForm v-if="currentForm == 'GatblacNewChatbotRequest'" />

    <!-- ALVI -->
    <AlviLoginForm v-if="currentForm == 'AlviLoginForm'" />
    <AlviContactoForm v-if="currentForm == 'AlviContactoForm'" />

    <!-- TUA -->
    <TUADudasCompraForm v-if="currentForm == 'TUADudasCompraForm'" />
    <TUAProductosProblemasForm
      v-if="currentForm == 'TUAProductosProblemasForm'"
    />
    <TUADevolucionPedidosForm
      v-if="currentForm == 'TUADevolucionPedidosForm'"
    />
    <TUAContactoForm
      v-if="currentForm == 'TUAContactoForm'"
    />
    <!-- DBShop -->
    <DBShopContactForm v-if="currentForm === 'DBShopContactForm'" />
    <DBShopProblemasCompraForm
      v-if="currentForm == 'DBShopProblemasCompraForm'"
    />
    <DBShopCambioDireccionEntregaForm
      v-if="currentForm == 'DBShopCambioDireccionEntregaForm'"
    />
    <DBShopEstadoPedidoForm v-if="currentForm == 'DBShopEstadoPedidoForm'" />
    <DBShopProblemasPedidosForm
      v-if="currentForm == 'DBShopProblemasPedidosForm'"
    />
    <!-- UNIBAG -->
    <UNIBAGCotizarForm v-if="currentForm == 'UNIBAGCotizarForm'" />

    <!-- CCU -->
    <CCUDistribucionForm v-if="currentForm == 'CCUDistribucionForm'" />
    <CCUOtrosForm v-if="currentForm == 'CCUOtrosForm'" />
    <CCUServicioTecnicoForm v-if="currentForm == 'CCUServicioTecnicoForm'" />
    <CCUVentasForm v-if="currentForm == 'CCUVentasForm'" />
    <CCUReclamoForm v-if="currentForm == 'CCUReclamoForm'" />
    <CCUReclamoCamionForm v-if="currentForm == 'CCUReclamoCamionForm'" />
    <CCUReclamoOtrosForm v-if="currentForm == 'CCUReclamoOtrosForm'" />
    <CCUFormularioOtros v-if="currentForm == 'CCUFormularioOtros'" />
    <CCUFormCRECCU v-if="currentForm == 'CCUFormCRECCU'" />

    <!-- Etienne -->
    <EtienneContactForm v-if="currentForm === 'EtienneContactForm'" />
    <EtienneProblemasCompraForm v-if="currentForm == 'EtienneProblemasCompraForm'" />
    <EtienneCambioDireccionEntregaForm v-if="currentForm == 'EtienneCambioDireccionEntregaForm'" />
    <EtienneEstadoPedidoForm v-if="currentForm == 'EtienneEstadoPedidoForm'" />
    <EtienneProblemasPedidosForm v-if="currentForm == 'EtienneProblemasPedidosForm'" />

    <!-- Kross -->
    <KrossDamagedProductForm v-if="currentForm == 'KrossDamagedProductForm'" />
    <KrossDeliveryDelayForm v-if="currentForm == 'KrossDeliveryDelayForm'" />
    <KrossWrongProductForm v-if="currentForm == 'KrossWrongProductForm'" />
    <KrossNewClientForm v-if="currentForm == 'KrossNewClientForm'" />

    <!-- Naturaloe -->
    <NaturaloeForm
      v-if=" currentForm === 'naturaloeContactForm' ||
        currentForm === 'naturaloePurchaseProblemsForm' ||
        currentForm === 'naturaloeChangeDeliveryAddressForm' ||
        currentForm === 'naturaloeOrderStatusForm'||
        currentForm === 'naturaloeOrderProblemsForm'
      "
      :form="currentForm"
    />

    <!-- CACEM -->
    <CacemContactForm v-if="currentForm == 'CacemContactForm'" />

    <!-- Gatblac -->
    <GatblacContactForm v-if="currentForm == 'GatblacContactForm'" />

    <!-- BEGIVER -->
    <BegiverForm v-if="currentForm === 'BegiverContactForm'" />
    <NegativeFeedbackForm v-if="currentForm == 'NegativeFeedbackForm'" />

    <!-- REALME -->
    <RealmeTechnicalServiceForm v-if="currentForm == 'RealmeTechnicalServiceForm'" />
    <RealmeProductExecutiveForm v-if="currentForm == 'RealmeProductExecutiveForm'" />

    <!-- Trial -->
    <TrialContactForm v-if="currentForm == 'TrialContactForm'" />

    <!-- Nuam -->
    <NuamContactForm v-if="currentForm == 'NuamContactForm'" />
    <NuamLeadsForm v-if="currentForm == 'NuamLeadsForm'" />
    <!-- A2censo -->
    <A2censoContactForm v-if="currentForm == 'A2censoContactForm'" />
    <!-- Bvc -->
    <BvcContactForm v-if="currentForm == 'BvcContactForm'" />
    <!-- Bsx -->
    <BsxContactForm v-if="currentForm == 'BsxContactForm'" />
    <!-- Bvl -->
    <BvlContactForm v-if="currentForm == 'BvlContactForm'" />

    <!-- MENSAJES -->
    <MessageList
      v-if="currentForm == ''"
      :messages="messages"
      :participants="participants"
      :show-typing-indicator="showTypingIndicator"
      :colors="colors"
      :always-scroll-to-bottom="alwaysScrollToBottom"
      :company-name="companyName"
    />
    <!-- ENTRADA TEXTO -->
    <UserInput
      v-if="currentForm == ''"
      :show-emoji="showEmoji"
      :on-submit="onUserInputSubmit"
      :suggestions="getSuggestions()"
      :show-file="showFile"
      :placeholder="placeholder"
      :plugin-enabled-microphone="pluginEnabledMicrophone"
      :colors="colors"
      :show-input="showInput"
      :show-information="showInformation"
      :last-user-text="lastUserText"
    />
  </div>
</template>

<script>
import Header from './Header.vue'
import MessageList from './MessageList.vue'
import UserInput from './UserInput.vue'

import Score from './Score.vue'
import ScoreConversation from './ScoreConversation.vue'
import LoginForm from './LoginForm.vue'
import ContactForm from './ContactForm.vue'
import CotizacionForm from './5f4697a061afb01ad9edf806-FormCotizar.vue'
import DiasLibresForm from './5f4697a061afb01ad9edf806-FormDiasLibres.vue'
import ChatbotRequestForm from './components/gatblac/formChatbotRequest.vue'
/** ALVI **/
import AlviLoginForm from './AlviLoginForm.vue'
import AlviContactoForm from './AlviContactoForm.vue'
/** TUA **/
import TUADudasCompraForm from './5f9c22b61637a942465a7980-FormDudasCompra.vue'
import TUAProductosProblemasForm from './5f9c22b61637a942465a7980-FormProductosProblemas.vue'
import TUADevolucionPedidosForm from './5f9c22b61637a942465a7980-FormDevolucionPedidos.vue'
import TUAContactoForm from './5f9c22b61637a942465a7980-FormContacto.vue'
/** DBSHOP **/
import DBShopContactForm from './components/dbshop/contact-form/DBShopContactForm.vue'
import DBShopProblemasCompraForm from './5feb4ea507c8a80f3f3212f5-FormProblemasCompra.vue'
import DBShopCambioDireccionEntregaForm from './5feb4ea507c8a80f3f3212f5-FormCambioDireccionEntrega.vue'
import DBShopEstadoPedidoForm from './5feb4ea507c8a80f3f3212f5-FormEstadoPedido.vue'
import DBShopProblemasPedidosForm from './5feb4ea507c8a80f3f3212f5-FormProblemasPedidos.vue'
/** UNIBAG **/
import UNIBAGCotizarForm from './5fabec0a0f3d4477c5199a01-FormCotizar.vue'
/** CCU **/
import CCUDistribucionForm from './60f5daf20a1812f31ec89c4a-FormDistribucion.vue'
import CCUOtrosForm from './60f5daf20a1812f31ec89c4a-FormOtros.vue'
import CCUServicioTecnicoForm from './60f5daf20a1812f31ec89c4a-FormServicioTecnico.vue'
import CCUVentasForm from './60f5daf20a1812f31ec89c4a-FormVentas.vue'
import CCUReclamoForm from './60f5daf20a1812f31ec89c4a-FormReclamo.vue'
import CCUReclamoCamionForm from './60f5daf20a1812f31ec89c4a-FormReclamoCamion.vue'
import CCUReclamoOtrosForm from './60f5daf20a1812f31ec89c4a-FormReclamoOtros.vue'
import CCUFormularioOtros from './60f5daf20a1812f31ec89c4a-FormOtrosFormulario.vue'
import CCUFormCRECCU from './60f5daf20a1812f31ec89c4a-FormCRECCUFormulario.vue'
/** DBSHOP **/
import EtienneContactForm from './components/etienne/contactForm.vue'
import EtienneProblemasCompraForm from './components/etienne/formProblemasCompra.vue'
import EtienneCambioDireccionEntregaForm from './components/etienne/formCambioDireccionEntrega.vue'
import EtienneEstadoPedidoForm from './components/etienne/formEstadoPedido.vue'
import EtienneProblemasPedidosForm from './components/etienne/formProblemasPedidos.vue'
/** KROSS **/
import KrossDamagedProductForm from './components/kross/formDamagedProduct.vue'
import KrossWrongProductForm from './components/kross/formWrongProduct.vue'
import KrossDeliveryDelayForm from './components/kross/formDeliveryDelay.vue'
import KrossNewClientForm from './components/kross/formNewClient.vue'
/** Naturaloe  **/
import NaturaloeForm from './components/naturaloe/form.vue'
/** CACEM  **/
import CacemContactForm from './components/cacem/formContact.vue'
/** GATBLAC  **/
import GatblacContactForm from './components/gatblac/formContact.vue'
/** BEGIVER **/
import BegiverForm from './components/begiver/form.vue'

import RealmeTechnicalServiceForm from './components/realme/formTechnicalServices.vue'
import RealmeProductExecutiveForm from './components/realme/formProductExecutive.vue'

/** Trial  **/
import TrialContactForm from './components/gb-trial/contact-form.vue'
/** Nuam  **/
import NuamContactForm from './components/nuam/contact-form.vue'
import NuamLeadsForm from './components/nuam/leads-form.vue'
/** A2censo  **/
import A2censoContactForm from './components/a2censo/contact-form.vue'
/** Bvc  **/
import BvcContactForm from './components/bvc/contact-form.vue'
/** Bsx  **/
import BsxContactForm from './components/bsx/contact-form.vue'
/** Bvl  **/
import BvlContactForm from './components/bvl/contact-form.vue'

// Form feedbacknegativo
import NegativeFeedbackForm from './NegativeFeedbackForm.vue'

export default {
  components: {
    Header,
    MessageList,
    UserInput,
    Score,
    ScoreConversation,
    LoginForm,
    ContactForm,
    CotizacionForm,
    DiasLibresForm,
    ChatbotRequestForm,
    /** ALVI **/
    AlviLoginForm,
    AlviContactoForm,
    /** TUA **/
    TUADudasCompraForm,
    TUAProductosProblemasForm,
    TUADevolucionPedidosForm,
    TUAContactoForm,
    /** DBSHOP **/
    DBShopContactForm,
    DBShopProblemasCompraForm,
    DBShopCambioDireccionEntregaForm,
    DBShopEstadoPedidoForm,
    DBShopProblemasPedidosForm,
    /** UNIBAG **/
    UNIBAGCotizarForm,
    /** CCU **/
    CCUDistribucionForm,
    CCUOtrosForm,
    CCUServicioTecnicoForm,
    CCUVentasForm,
    CCUReclamoForm,
    CCUReclamoCamionForm,
    CCUReclamoOtrosForm,
    CCUFormularioOtros,
    CCUFormCRECCU,
    /** Etienne **/
    EtienneContactForm,
    EtienneProblemasCompraForm,
    EtienneCambioDireccionEntregaForm,
    EtienneEstadoPedidoForm,
    EtienneProblemasPedidosForm,
    /** Kross **/
    KrossDamagedProductForm,
    KrossWrongProductForm,
    KrossDeliveryDelayForm,
    KrossNewClientForm,
    /** Naturaloe **/
    NaturaloeForm,
    /** CACEM **/
    CacemContactForm,
    /** Gatblac **/
    GatblacContactForm,
    /**  BEGIVER **/
    BegiverForm,
    /** REALME **/
    RealmeTechnicalServiceForm,
    RealmeProductExecutiveForm,
    /** Trial **/
    TrialContactForm,
    /** Nuam **/
    NuamContactForm,
    NuamLeadsForm,
    /** A2censo **/
    A2censoContactForm,
    /** Bvc **/
    BvcContactForm,
    /** Bsx **/
    BsxContactForm,
    /** Bvl **/
    BvlContactForm,
    // Form feedbacknegativo
    NegativeFeedbackForm
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    showFile: {
      type: Boolean,
      default: false
    },
    showInformation: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    imageUrl: {
      type: String,
      default: ''
    },
    isEmbedded: {
      type: Boolean
    },
    onUserInputSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: () => []
    },
    chatStatus: {
      type: String,
      default: () => ''
    },
    placeholder: {
      type: String,
      default: '...'
    },
    pluginEnabledMicrophone: {
      type: Boolean,
      default: false
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    currentForm: {
      type: String,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    showInput: {
      type: String
    },
    cssStyle: {
      type: Object
    },
    lastUserText: {
      type: String,
      default: ''
    },
    companyName: {
      type: String,
      default: ''
    },
    welcomeFormLogo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    messages () {
      const messages = this.messageList
      return messages
    }
  },
  created () {},
  methods: {
    getSuggestions () {
      return this.messages.length > 0
        ? this.messages[this.messages.length - 1].suggestions
        : []
    }
  }
}
</script>
<style scoped>
.sc-chat-window {
  width: 370px;
  height: calc(100% - 120px);
  max-height: 590px;
  position: fixed;
  right: 70px;
  bottom: 105px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-shadow: 0 7px 30px 1px rgba(148, 149, 150, 0.3);
  -webkit-box-shadow: 0 7px 30px 1px rgba(148, 149, 150, 0.3);
  background: #f7f7f7;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -ms-flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  border-radius: 15px;
}

.sc-chat-window.closed {
  opacity: 0;
  visibility: hidden;
  bottom: 90px;
}

.sc-message--me {
  text-align: right;
}
.sc-message--them {
  text-align: left;
}

@media (max-width: 450px) {
  .sc-chat-window {
    width: 100%;
    height: 100%;
    max-height: 100%;
    right: 0px;
    bottom: 0px;
  border-radius: 15px;
  }
  .sc-chat-window {
    transition: 0.1s ease-in-out;
  }
  .sc-chat-window.closed {
    bottom: 0px;
  }
}
</style>
